export default function importFontFamily(font) {
  document.documentElement.style
    .setProperty('font-family', font);
}
